const admin: any = {
    menu: /admin:*/,
    tool: 'admin:tools',
    scriptEditor: 'admin:script_editor'
}

export default admin;